/**
 * Translation engines: the two DeepL models and the Diplo-hosted Argos engines.
 *
 * The choice is a user preference rather than a session property: it is kept in
 * localStorage and sent with each translation request (as `model_type`) so the
 * engines can be compared side by side on the same report.
 */

const STORAGE_KEY = 'deeplModelType';

const DEEPL_MODEL_LATENCY = 'latency_optimized';
const DEEPL_MODEL_QUALITY = 'quality_optimized';
const ARGOS_MODEL = 'argos';
const ARGOS_LANGUAGETOOL_MODEL = 'argos_languagetool';

export const DEEPL_MODELS = [
  {
    value: DEEPL_MODEL_LATENCY,
    label: 'Fast',
    description: "DeepL's classic model. Near-instant, excellent for transcripts.",
  },
  {
    value: DEEPL_MODEL_QUALITY,
    label: 'High quality',
    description: 'Next-generation LLM model. More natural phrasing, slower.',
  },
];

// Experimental engines, shown only under "Advanced" in the picker.
export const ADVANCED_MODELS = [
  {
    value: ARGOS_MODEL,
    label: 'Argos',
    description: 'Diplo-hosted Argos Translate. English to French only for now.',
  },
  {
    value: ARGOS_LANGUAGETOOL_MODEL,
    label: 'Argos + LanguageTool',
    description:
      'Argos Translate, then corrected by Diplo LanguageTool. English to French only, slower.',
  },
];

const ALL_MODELS = [...DEEPL_MODELS, ...ADVANCED_MODELS];

const DEFAULT_DEEPL_MODEL = DEEPL_MODEL_LATENCY;

export function isAdvancedModel(value) {
  return ADVANCED_MODELS.some((m) => m.value === value);
}

export function getDeepLModelType() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return ALL_MODELS.some((m) => m.value === stored) ? stored : DEFAULT_DEEPL_MODEL;
  } catch {
    return DEFAULT_DEEPL_MODEL;
  }
}

export function setDeepLModelType(value) {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Preference is best-effort; translation still works with the default.
  }
}
